import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400 533.017"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("g", {
        fill: "#06999a",
        "data-name": "Calque 1"
      }, [
        _createElementVNode("path", { d: "M400 103.426C342.899 4.523 216.433-29.364 117.53 27.738 18.628 84.839-15.259 211.305 41.843 310.208zM0 429.591c57.101 98.903 183.567 132.79 282.47 75.688 98.902-57.101 132.789-183.567 75.687-282.47z" })
      ])
    ], -1)
  ])))
}
export default { render: render }